module.exports = __webpack_public_path__ + "static/media/LT3-BG1.523e790e.jpg";